/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import useFormValidator from 'useFormValidator';
import { ucwords } from '../../../../helper';
import * as actions from '../../../../actions';
import * as c from '../../../../constant';

function UpdateNewBusinessActivity({
  formData,
  getBusinessNaturesList,
  businessNaturesList,
  getBusinessLinesList,
  businessLinesList,
  getNecessaryFieldsList,
  necessaryFieldsList,
  setFormData,
  closeModal,
  handleOnUpdate,
  businessActivityInfo,
}) {
  const [formDataMultiplier, setFormDataMultiplier] = useState({});
  const [multiplierData, setMultiplierData] = useState({});
  const [optionFields, setOptionFields] = useState([]);

  const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, '');

  const commonValidation = {
    business_nature_id: 'required',
    business_line_id: 'required',
    capital_amount: 'required',
  };

  const validateForm = useFormValidator(formData, commonValidation);

  useEffect(() => {
    getBusinessNaturesList();
  }, []);

  const validateMultiplier = Object.keys(formDataMultiplier)
    .map(item => {
      return { [item]: 'required' };
    })
    .values();

  const setValidateMultiplier = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const value of validateMultiplier) {
      setMultiplierData(prevData => ({
        ...prevData,
        ...value,
      }));
    }
  };

  const validateFormMultiplier = useFormValidator(
    formDataMultiplier,
    multiplierData
  );

  useEffect(() => {
    setValidateMultiplier();
  }, [ formDataMultiplier, _.get(formData, 'business_line_id')]);

  useEffect(() => {
    validateFormMultiplier.onSetObjectRules(multiplierData);
  }, [multiplierData, formDataMultiplier]);

  const handleNatureDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      business_line_id: '',
    });

    getBusinessLinesList({ business_nature_id: e.value });
    setFormDataMultiplier({});
    setMultiplierData({});
  };

  const selectBusinessNatureId = businessNaturesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleLineDropDownChange = key => e => {
    setFormDataMultiplier({});
    setMultiplierData({});
    setOptionFields([]);

    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      line_of_business: e.label,
    });

    // getNecessaryFieldsList({ business_line_id: e.value });
    getNecessaryFieldsList({ business_line_id: e.value }, ({data}) => {
      setOptionFields(data);
      if(_.isEmpty(formDataMultiplier)) {
        setFormDataMultiplier({
          ...(data.map((item) => item.multiplier)).reduce((ac, label) => ({...ac,[label]:''}),{}),
        })
      } 
      else {
        setFormDataMultiplier({
          ...formDataMultiplier,
        })
      }
    });
  };

  const onChangeMultiplier = e => {
    setFormDataMultiplier({
      ...formDataMultiplier,
      [e.target.name]: addCommas(removeNonNumeric(e.target.value)),
    });

    setFormData({
      ...formData,
      [e.target.name]: addCommas(removeNonNumeric(e.target.value)),
    });
  };

  const onChangeMultiplierSelect = key => e => {
    setFormDataMultiplier({
      ...formDataMultiplier,
      [key]: e ? e.value : '',
    });
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  }

  useEffect(() => {
    validateFormMultiplier.validate();
  }, []);

  const selectBusinessLineId = businessLinesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  // const handleOfficeTypeDropDownChange = key => e => {
  //   setFormData({
  //     ...formData,
  //     [key]: e ? e.value : '',
  //   });
  // };

  const selectOptions = list => {
    const newList = [];

    list.map(data => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, x => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  useEffect(() => {
    if (!_.isEmpty(businessActivityInfo)) {
      getBusinessLinesList({
        business_nature_id: _.get(businessActivityInfo, 'business_nature_id'),
      });
      if (_.get(businessActivityInfo, 'business_line_id')) {
        getNecessaryFieldsList({ business_line_id: _.get(businessActivityInfo, 'business_line_id'), }, (data) => {
          setOptionFields(_.get(data, 'data'));
        });
      }

      let keyValues = [];
      keyValues = Object.entries(
        _.get(businessActivityInfo, 'details') || ''
      ).map(([key, value]) => ({
        [key]: value.toString() || '',
      }));

      let finalObject = {};
      const badCallback = (a, i) => Object.assign(a, i);
      finalObject = keyValues.reduce(badCallback, {});

      setFormData({
        ...formData,
        ...finalObject,
        business_nature_id:
          _.get(businessActivityInfo, 'business_nature_id') !== undefined
            ? _.get(businessActivityInfo, 'business_nature_id')
            : '',
        business_line_id:
          _.get(businessActivityInfo, 'business_line_id') !== undefined
            ? _.get(businessActivityInfo, 'business_line_id')
            : '',
        capital_amount: _.get(businessActivityInfo, 'capital_amount'),
        id: _.get(businessActivityInfo, 'id'),
        activity_id: _.get(businessActivityInfo, 'activity_id'),
        initial_data: _.get(businessActivityInfo, 'initial_data'),
      });
      setFormDataMultiplier({
        ...finalObject,
      });
    }
  }, []);

  // useEffect(() => {
  //   setFormDataMultiplier({})
  //   setMultiplierData({})
  // }, [_.get(formData, 'business_nature_id')])

  const findBusinessNatureValue =
    selectBusinessNatureId.find(
      item => +_.get(formData, 'business_nature_id') === +item.id
    ) || '';

  const findBusinessLineValue =
    selectBusinessLineId.find(
      item => +_.get(formData, 'business_line_id') === +item.id
    ) || '';
  return (
    <div>
      <div className="row p-2">
        <div className="col-4 my-2">
          <label className="text-primary font-weight-bold">
            Line of Business : &nbsp;
          </label>
          <b>{_.get(formData, 'initial_data.line_of_business')}</b>
        </div>
        <div className="col-4 my-2">
          <label className="text-primary font-weight-bold">
            Number of Units : &nbsp;
          </label>
          <b>
            {_.get(formData, 'initial_data.no_of_units')
              ? parseFloat(
                  _.get(businessActivityInfo, 'initial_data.no_of_units') || 0,
                  10
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : '0.00'}
          </b>
        </div>
        <div className="col-4 my-2">
          <label className="text-primary font-weight-bold">
            Service : &nbsp;
          </label>
          <b>{_.get(businessActivityInfo, 'initial_data.service') || '--'}</b>
        </div>
      </div>
      <div className="row">
        <div className="col-6 form-group">
          <label className="form-label">
            Business Nature:
            {validateForm.renderMessage('business_nature_id')}
          </label>
          <Select
            options={selectBusinessNatureId}
            placeholder="Select Business Nature"
            onChange={handleNatureDropDownChange('business_nature_id')}
            value={findBusinessNatureValue}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">
            Business Line:
            {validateForm.renderMessage('business_line_id')}
          </label>
          <Select
            options={selectBusinessLineId}
            placeholder="Select Business Line"
            value={findBusinessLineValue}
            onChange={handleLineDropDownChange('business_line_id')}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">
            Capital Amount: {validateForm.renderMessage('capital_amount')}
          </label>
          <NumberFormat
            name="capital_amount"
            id="capital_amount"
            placeholder=""
            className="form-control"
            onValueChange={values => {
              const { value } = values;
              setFormData({
                ...formData,
                capital_amount: value,
              });
            }}
            /* eslint-disable */
            isNumericString={true}
            thousandSeparator={true}
            allowNegative={true}
            allowLeadingZeros={true}
            displayType="input"
            prefix=""
            value={_.get(formData, 'capital_amount', '') || ''}
            isAllowed={values => {
              const { value } = values;
              return value === '' || value <= 999999999999999;
            }}
          />
        </div>
        <div className="col-12 form-group">
          {_.get(formData, 'business_line_id') !== '' && necessaryFieldsList.map((item, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <div key={`${_.get(item, 'multiplier')}+${index}`}>
                <div>
                  {_.get(item, 'options') ? (
                    <div>
                      <label className="form-label">
                        {ucwords(_.get(item, 'multiplier').replace(/_/g, ' '))}
                        {validateFormMultiplier.renderMessage(
                          `${item.multiplier}`
                        )}
                      </label>
                      <Select
                        onChange={onChangeMultiplierSelect(
                          _.get(item, 'multiplier')
                        )}
                        value={
                          selectOptions(_.get(item, 'options')).find(
                            x =>
                              _.get(formDataMultiplier, _.get(item, 'multiplier')) ===
                              _.get(x, 'value')
                          ) || ''
                        }
                        options={selectOptions(_.get(item, 'options'))}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group">
                  {!_.get(item, 'options') ? (
                    <div>
                      <label className="form-label">
                        {ucwords(item.multiplier.replace(/_/g, ' '))}:
                        {validateFormMultiplier.renderMessage(
                          `${item.multiplier}`
                        )}
                      </label>
                      <input
                        name={item.multiplier}
                        onChange={onChangeMultiplier}
                        className="form-control"
                        value={
                          _.get(
                            formData,
                            _.get(item, 'multiplier')
                          ) || ''
                        }
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex justify-content-end pb-3">
        <button
          disabled={
            !validateForm.response.is_passed ||
            !validateFormMultiplier.response.is_passed
          }
          type="button"
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          onClick={handleOnUpdate(formData, optionFields)}
        >
          <span className="font-weight-bold">Update</span>
        </button>
        <button
          type="button"
          onClick={() => closeModal()}
          className="mt-3 btn btn-dark "
        >
          <span className="font-weight-bold">Cancel</span>
        </button>
      </div>
    </div>
  );
}

UpdateNewBusinessActivity.defaultProps = {
  businessActivityInfo: {},
};

UpdateNewBusinessActivity.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  getBusinessNaturesList: PropTypes.instanceOf(Function).isRequired,
  businessNaturesList: PropTypes.instanceOf(Array).isRequired,
  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLinesList: PropTypes.instanceOf(Array).isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  closeModal: PropTypes.instanceOf(Function).isRequired,
  handleOnUpdate: PropTypes.instanceOf(Function).isRequired,
  businessActivityInfo: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  businessNaturesList: _.get(api, `${c.GET_BUSINESS_NATURES_LIST}.list`) || [],
  businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateNewBusinessActivity);
